var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarParticipant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 119,
    viewBox: "0 0 154 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.735 25.1641L105.172 28.751V40.7529L143.382 37.9305C145.89 37.7472 147.954 36.3805 149.106 34.1445L153.735 25.1641Z",
    fill: "url(#paint0_linear_308_8132)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.172 39.6399L143.984 36.7703C146.493 36.587 148.556 35.2203 149.708 32.9844L149.106 34.1469C147.954 36.3828 145.89 37.7495 143.382 37.9328L105.172 40.7552V39.6346V39.6399Z",
    fill: "url(#paint1_linear_308_8132)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.382 37.9336L105.172 40.756V52.7579L133.035 50.7C135.543 50.5167 137.606 49.15 138.758 46.9141L143.387 37.9336H143.382Z",
    fill: "url(#paint2_linear_308_8132)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.175 51.641L133.635 49.5359C136.143 49.3527 138.207 47.986 139.359 45.75L138.756 46.9125C137.604 49.1484 135.541 50.5152 133.033 50.6984L105.17 52.7563V51.6357L105.175 51.641Z",
    fill: "url(#paint3_linear_308_8132)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.033 50.6992L105.17 52.7571V64.759L122.681 63.4656C125.189 63.2824 127.252 61.9157 128.404 59.6797L133.033 50.6992Z",
    fill: "url(#paint4_linear_308_8132)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.175 63.6382L123.283 62.2977C125.791 62.1144 127.854 60.7477 129.006 58.5117L128.404 59.6742C127.252 61.9102 125.189 63.2769 122.681 63.4601L105.17 64.7535V63.6329L105.175 63.6382Z",
    fill: "url(#paint5_linear_308_8132)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.712891 25.1641L49.2756 28.751V40.7529L11.0653 37.9305C8.55707 37.7472 6.49391 36.3805 5.3419 34.1445L0.712891 25.1641Z",
    fill: "url(#paint6_linear_308_8132)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.278 39.6399L10.4656 36.7703C7.95736 36.587 5.8942 35.2203 4.74219 32.9844L5.34438 34.1469C6.49639 36.3828 8.55955 37.7495 11.0678 37.9328L49.278 40.7552V39.6346V39.6399Z",
    fill: "url(#paint7_linear_308_8132)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0677 37.9336L49.278 40.756V52.7579L21.4149 50.7C18.9067 50.5167 16.8435 49.15 15.6915 46.9141L11.0625 37.9336H11.0677Z",
    fill: "url(#paint8_linear_308_8132)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2772 51.641L20.8172 49.5359C18.3089 49.3527 16.2458 47.986 15.0938 45.75L15.6959 46.9125C16.848 49.1484 18.9111 50.5152 21.4194 50.6984L49.2824 52.7563V51.6357L49.2772 51.641Z",
    fill: "url(#paint9_linear_308_8132)"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4141 50.6992L49.2771 52.7571V64.759L31.7665 63.4656C29.2582 63.2824 27.1951 61.9157 26.0431 59.6797L21.4141 50.6992Z",
    fill: "url(#paint10_linear_308_8132)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2763 63.6382L31.1687 62.2977C28.6605 62.1144 26.5973 60.7477 25.4453 58.5117L26.0475 59.6742C27.1995 61.9102 29.2627 63.2769 31.7709 63.4601L49.2816 64.7535V63.6329L49.2763 63.6382Z",
    fill: "url(#paint11_linear_308_8132)"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.8727 95.1733C68.9028 92.4347 60.7706 89.1253 54.6074 83.1871C45.1504 74.0758 42.8516 60.7752 42.8516 48.1921V21.4287L43.5428 21.1616C54.2199 17.0301 65.7243 14.1448 77.1031 12.8933L77.2235 12.8828L77.3439 12.8933C88.7227 14.15 100.227 17.0301 110.904 21.1616L111.595 21.4287V48.1921C111.595 60.7805 109.297 74.0758 99.8397 83.1871C93.6764 89.1253 85.5494 92.4347 77.5743 95.1733L77.2235 95.2938L76.8727 95.1733Z",
    fill: "url(#paint12_linear_308_8132)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3639 18.4082C50.5648 13.2817 64.1481 9.73141 77.2235 8.35946V2.76172C61.7655 4.3117 45.8834 8.83074 32.7871 14.7636L38.3587 18.4134L38.3639 18.4082Z",
    fill: "url(#paint13_linear_308_8132)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.2228 8.35938C64.1475 9.73132 50.5589 13.2816 38.3633 18.4081L43.9348 22.1678C54.5386 18.0625 66.0745 15.1877 77.2228 13.9624V8.35938Z",
    fill: "url(#paint14_linear_308_8132)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3626 48.1924V18.4076L32.791 14.7578V48.1924C32.791 90.4243 57.5436 99.3681 77.2274 105.914V100.038C67.9484 96.9122 58.6799 93.3462 51.4956 86.4236C41.1012 76.4063 38.3678 62.1109 38.3678 48.1924H38.3626Z",
    fill: "url(#paint15_linear_308_8132)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3646 18.4062V48.1911C38.3646 62.1095 41.098 76.405 51.4923 86.4223C58.6715 93.3448 67.9452 96.9109 77.2242 100.037V94.1512C69.3695 91.4492 61.3735 88.2027 55.3568 82.4112C46.1407 73.5302 43.9309 60.481 43.9309 48.1911V22.166L38.3594 18.4062H38.3646Z",
    fill: "url(#paint16_linear_308_8132)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.088 18.4082C103.887 13.2817 90.3039 9.73141 77.2285 8.35946V2.76172C92.6865 4.3117 108.569 8.83074 121.665 14.7636L116.093 18.4134L116.088 18.4082Z",
    fill: "url(#paint17_linear_308_8132)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.2227 8.35938C90.298 9.73132 103.887 13.2816 116.082 18.4081L110.511 22.1678C99.9069 18.0625 88.3658 15.1877 77.2227 13.9624V8.35938Z",
    fill: "url(#paint18_linear_308_8132)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.087 48.1924V18.4076L121.659 14.7578V48.1924C121.659 90.4243 96.9064 99.3681 77.2227 105.914V100.038C86.5016 96.9122 95.7701 93.3462 102.954 86.4236C113.349 76.4063 116.082 62.1109 116.082 48.1924H116.087Z",
    fill: "url(#paint19_linear_308_8132)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.088 18.4062V48.1911C116.088 62.1095 113.355 76.405 102.96 86.4223C95.776 93.3448 86.5075 96.9109 77.2285 100.037V94.1512C85.0832 91.4492 93.0792 88.2027 99.0959 82.4112C108.312 73.5302 110.522 60.481 110.522 48.1911V22.166L116.093 18.4062H116.088Z",
    fill: "url(#paint20_linear_308_8132)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9336 22.1664C54.396 18.3176 68.7176 16.3069 77.2216 15.9717C85.7256 16.3069 100.047 18.3124 110.51 22.1664C99.9058 18.0611 88.3647 15.1863 77.2216 13.9609C66.0732 15.1863 54.5374 18.0611 43.9336 22.1664Z",
    fill: "url(#paint21_radial_308_8132)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.3128 78.2235C85.4467 90.8642 68.9938 90.8642 55.1277 78.2235C48.2942 71.9974 45.2885 63.6505 44.1836 55.0156C44.9795 65.1376 47.8334 75.1602 55.3529 82.4074C61.3643 88.1989 69.3604 91.4507 77.2203 94.1475C85.0749 91.4455 93.0709 88.1989 99.0876 82.4074C106.612 75.1602 109.461 65.1324 110.257 55.0156C109.152 63.6453 106.146 71.9921 99.3128 78.2183V78.2235Z",
    fill: "url(#paint22_radial_308_8132)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3832 58.8418C63.2868 58.8418 51.3948 53.265 47.6822 45.6408C45.9908 42.169 45.9542 24.606 48.2949 23.2393C53.5889 20.1498 69.5495 17.4688 77.3832 17.4688C85.2169 17.4688 101.178 20.1498 106.472 23.2393C108.812 24.606 108.776 42.1742 107.084 45.6408C103.372 53.265 91.4797 58.8418 77.3832 58.8418Z",
    fill: "url(#paint23_radial_308_8132)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.2245 48.3425C66.1285 48.3425 56.7657 44.6351 53.8438 39.561C52.5137 37.2517 52.4823 23.9407 54.3255 23.0348C58.4937 20.9769 70.3438 18.7305 77.2245 18.7305C84.1051 18.7305 95.9552 20.9769 100.123 23.0348C101.967 23.946 101.935 37.257 100.605 39.561C97.6832 44.6299 88.3205 48.3425 77.2245 48.3425Z",
    fill: "url(#paint24_radial_308_8132)"
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5499 46.448C37.5499 55.0096 38.0788 58.3242 40.299 66.1213C38.8695 60.3246 38.3563 54.2241 38.3563 48.1917V18.4069C49.9603 13.5318 62.8209 10.081 75.2994 8.57812C67.8636 9.41595 61.3181 10.5104 54.8616 12.1441C54.516 11.72 53.9399 11.5158 53.3849 11.6781C52.8508 11.8352 52.479 12.2803 52.3952 12.7935C50.9761 13.1862 49.5518 13.6051 48.1223 14.0554C47.5882 13.4951 46.7608 13.2595 45.9806 13.5266C45.2108 13.7884 44.6976 14.4639 44.6034 15.2179C42.4983 15.9458 40.3566 16.747 38.1573 17.6214L33.5859 15.2808L37.5499 18.5849V46.448Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M48.9105 25.2039C55.7183 25.2039 61.2371 19.6851 61.2371 12.8773C61.2371 6.06957 55.7183 0.550781 48.9105 0.550781C42.1028 0.550781 36.584 6.06957 36.584 12.8773C36.584 19.6851 42.1028 25.2039 48.9105 25.2039Z",
    fill: "url(#paint25_radial_308_8132)"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6992 102.372L42.9696 108.719V102.372H21.6992Z",
    fill: "#CD74D7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M132.738 102.372L111.473 108.719V102.372H132.738Z",
    fill: "#CD74D7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9705 108.72L26.6328 114.559V103.85L42.9705 108.72Z",
    fill: "#E195E9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M111.473 108.72L127.805 114.559V103.85L111.473 108.72Z",
    fill: "#E195E9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8016 111.635V118.27L26.6328 114.557L34.8016 111.635Z",
    fill: "#D17FDA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M119.639 111.635V118.27L127.802 114.557L119.639 111.635Z",
    fill: "#D17FDA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_308_8132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3418 76.4285H137.481L132.926 102.375H21.8923L17.3418 76.4285Z",
    fill: "#5F488A"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_308_8132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.2339 91.8234C36.3859 91.8234 35.6459 91.6794 35.0139 91.3914C35.0139 91.1914 35.0299 91.0154 35.0619 90.8634C35.0939 90.7114 35.1459 90.5554 35.2179 90.3954C35.4179 90.5874 35.6899 90.7394 36.0339 90.8514C36.3779 90.9554 36.7499 91.0074 37.1499 91.0074C37.5259 91.0074 37.8139 90.9394 38.0139 90.8034C38.2219 90.6674 38.3259 90.4754 38.3259 90.2274C38.3259 90.0114 38.2219 89.8314 38.0139 89.6874C37.8139 89.5354 37.4939 89.3554 37.0539 89.1474C36.6299 88.9474 36.2859 88.7674 36.0219 88.6074C35.7659 88.4394 35.5419 88.2274 35.3499 87.9714C35.1579 87.7074 35.0619 87.3954 35.0619 87.0354C35.0619 86.5154 35.2939 86.0954 35.7579 85.7754C36.2219 85.4554 36.8459 85.2954 37.6299 85.2954C38.3819 85.2954 39.0219 85.3914 39.5499 85.5834C39.5499 85.8074 39.5019 86.0634 39.4059 86.3514C39.3179 86.6394 39.2099 86.8674 39.0819 87.0354C38.7299 86.7634 38.3699 86.5434 38.0019 86.3754C37.6419 86.1994 37.3379 86.1114 37.0899 86.1114C36.9539 86.1354 36.8259 86.2114 36.7059 86.3394C36.5859 86.4594 36.5259 86.6074 36.5259 86.7834C36.5259 87.0154 36.6259 87.2074 36.8259 87.3594C37.0339 87.5114 37.3659 87.6954 37.8219 87.9114C38.2299 88.1034 38.5659 88.2794 38.8299 88.4394C39.0939 88.5994 39.3179 88.8074 39.5019 89.0634C39.6859 89.3194 39.7779 89.6314 39.7779 89.9994C39.7779 90.5834 39.5659 91.0354 39.1419 91.3554C38.7179 91.6674 38.0819 91.8234 37.2339 91.8234ZM42.9092 91.7634C42.6772 91.7634 42.3932 91.7394 42.0572 91.6914C42.0972 91.2754 42.1292 90.7234 42.1532 90.0354C42.1772 89.3394 42.1892 88.6914 42.1892 88.0914C42.1892 87.5794 42.1732 87.0594 42.1412 86.5314C41.1572 86.5394 40.5452 86.5914 40.3052 86.6874C40.2652 86.4074 40.2452 86.1714 40.2452 85.9794C40.2452 85.8194 40.2652 85.6194 40.3052 85.3794C40.6332 85.4114 41.0732 85.4394 41.6252 85.4634C42.1852 85.4794 42.7132 85.4874 43.2092 85.4874C44.4012 85.4874 45.1372 85.4354 45.4172 85.3314C45.4572 85.5874 45.4772 85.7994 45.4772 85.9674C45.4772 86.1754 45.4572 86.3994 45.4172 86.6394C44.9532 86.5994 44.3452 86.5674 43.5932 86.5434C43.5532 87.3674 43.5332 88.1754 43.5332 88.9674C43.5332 90.4314 43.5972 91.3394 43.7252 91.6914C43.5092 91.7394 43.2372 91.7634 42.9092 91.7634ZM50.497 91.7514C50.249 91.7514 49.981 91.7234 49.693 91.6674C49.445 90.9554 49.269 90.4594 49.165 90.1794C48.741 90.1554 48.277 90.1434 47.773 90.1434C47.229 90.1434 46.845 90.1594 46.621 90.1914C46.485 90.5514 46.309 91.0434 46.093 91.6674C45.917 91.7154 45.757 91.7394 45.613 91.7394C45.429 91.7394 45.241 91.7154 45.049 91.6674C45.273 91.2674 45.669 90.3234 46.237 88.8354C46.805 87.3474 47.229 86.1834 47.509 85.3434C47.789 85.3034 48.025 85.2834 48.217 85.2834C48.417 85.2834 48.637 85.3034 48.877 85.3434C49.157 86.1834 49.581 87.3474 50.149 88.8354C50.717 90.3234 51.113 91.2674 51.337 91.6674C51.081 91.7234 50.801 91.7514 50.497 91.7514ZM48.229 89.3154C48.397 89.3154 48.601 89.3074 48.841 89.2914C48.465 88.2514 48.149 87.4354 47.893 86.8434C47.637 87.4674 47.325 88.2794 46.957 89.2794C47.349 89.3034 47.773 89.3154 48.229 89.3154ZM52.9597 91.7634C52.7037 91.7634 52.4117 91.7394 52.0837 91.6914C52.1237 91.2994 52.1557 90.7594 52.1797 90.0714C52.2037 89.3754 52.2157 88.7354 52.2157 88.1514C52.2157 86.7834 52.1517 85.9434 52.0237 85.6314C52.2797 85.5354 52.6317 85.4594 53.0797 85.4034C53.5277 85.3394 53.9757 85.3074 54.4237 85.3074C55.2637 85.3074 55.9077 85.4914 56.3557 85.8594C56.8117 86.2194 57.0397 86.7394 57.0397 87.4194C57.0397 87.8114 56.9317 88.1634 56.7157 88.4754C56.5077 88.7794 56.2157 89.0234 55.8397 89.2074C56.4637 90.4314 56.9597 91.1994 57.3277 91.5114C57.0637 91.6074 56.7917 91.6714 56.5117 91.7034C56.2397 91.7434 55.9277 91.7634 55.5757 91.7634C55.4157 91.3394 55.0477 90.5914 54.4717 89.5194L54.2797 89.5314C54.1197 89.5314 53.8797 89.5114 53.5597 89.4714C53.5677 90.5994 53.6317 91.3394 53.7517 91.6914C53.4877 91.7394 53.2237 91.7634 52.9597 91.7634ZM54.7477 88.7634C54.9957 88.6354 55.1957 88.4634 55.3477 88.2474C55.4997 88.0314 55.5757 87.7874 55.5757 87.5154C55.5757 86.6674 55.1077 86.2434 54.1717 86.2434C53.9637 86.2434 53.7837 86.2634 53.6317 86.3034C53.5997 86.9114 53.5757 87.6474 53.5597 88.5114C54.0877 88.6794 54.4837 88.7634 54.7477 88.7634ZM61.9363 91.7634C61.6803 91.7634 61.3883 91.7394 61.0603 91.6914C61.1003 91.2994 61.1323 90.7634 61.1563 90.0834C61.1803 89.3954 61.1923 88.7514 61.1923 88.1514C61.1923 86.7834 61.1283 85.9434 61.0003 85.6314C61.2563 85.5354 61.6083 85.4594 62.0563 85.4034C62.5043 85.3394 62.9523 85.3074 63.4003 85.3074C64.2403 85.3074 64.8843 85.4914 65.3323 85.8594C65.7883 86.2194 66.0163 86.7394 66.0163 87.4194C66.0163 87.8754 65.9003 88.2834 65.6683 88.6434C65.4363 88.9954 65.1123 89.2714 64.6963 89.4714C64.2883 89.6714 63.8163 89.7714 63.2803 89.7714C63.0483 89.7714 62.8043 89.7514 62.5483 89.7114C62.5643 90.7354 62.6243 91.3954 62.7283 91.6914C62.4643 91.7394 62.2003 91.7634 61.9363 91.7634ZM63.7243 89.0034C63.9643 88.8754 64.1603 88.6794 64.3123 88.4154C64.4723 88.1434 64.5523 87.8434 64.5523 87.5154C64.5523 86.6674 64.0843 86.2434 63.1483 86.2434C62.9403 86.2434 62.7603 86.2634 62.6083 86.3034C62.5603 87.2474 62.5363 88.0674 62.5363 88.7634C63.0563 88.9234 63.4523 89.0034 63.7243 89.0034ZM71.79 91.7514C71.542 91.7514 71.274 91.7234 70.986 91.6674C70.738 90.9554 70.562 90.4594 70.458 90.1794C70.034 90.1554 69.57 90.1434 69.066 90.1434C68.522 90.1434 68.138 90.1594 67.914 90.1914C67.778 90.5514 67.602 91.0434 67.386 91.6674C67.21 91.7154 67.05 91.7394 66.906 91.7394C66.722 91.7394 66.534 91.7154 66.342 91.6674C66.566 91.2674 66.962 90.3234 67.53 88.8354C68.098 87.3474 68.522 86.1834 68.802 85.3434C69.082 85.3034 69.318 85.2834 69.51 85.2834C69.71 85.2834 69.93 85.3034 70.17 85.3434C70.45 86.1834 70.874 87.3474 71.442 88.8354C72.01 90.3234 72.406 91.2674 72.63 91.6674C72.374 91.7234 72.094 91.7514 71.79 91.7514ZM69.522 89.3154C69.69 89.3154 69.894 89.3074 70.134 89.2914C69.758 88.2514 69.442 87.4354 69.186 86.8434C68.93 87.4674 68.618 88.2794 68.25 89.2794C68.642 89.3034 69.066 89.3154 69.522 89.3154ZM74.2527 91.7634C73.9967 91.7634 73.7047 91.7394 73.3767 91.6914C73.4167 91.2994 73.4487 90.7594 73.4727 90.0714C73.4967 89.3754 73.5087 88.7354 73.5087 88.1514C73.5087 86.7834 73.4447 85.9434 73.3167 85.6314C73.5727 85.5354 73.9247 85.4594 74.3727 85.4034C74.8207 85.3394 75.2687 85.3074 75.7167 85.3074C76.5567 85.3074 77.2007 85.4914 77.6487 85.8594C78.1047 86.2194 78.3327 86.7394 78.3327 87.4194C78.3327 87.8114 78.2247 88.1634 78.0087 88.4754C77.8007 88.7794 77.5087 89.0234 77.1327 89.2074C77.7567 90.4314 78.2527 91.1994 78.6207 91.5114C78.3567 91.6074 78.0847 91.6714 77.8047 91.7034C77.5327 91.7434 77.2207 91.7634 76.8687 91.7634C76.7087 91.3394 76.3407 90.5914 75.7647 89.5194L75.5727 89.5314C75.4127 89.5314 75.1727 89.5114 74.8527 89.4714C74.8607 90.5994 74.9247 91.3394 75.0447 91.6914C74.7807 91.7394 74.5167 91.7634 74.2527 91.7634ZM76.0407 88.7634C76.2887 88.6354 76.4887 88.4634 76.6407 88.2474C76.7927 88.0314 76.8687 87.7874 76.8687 87.5154C76.8687 86.6674 76.4007 86.2434 75.4647 86.2434C75.2567 86.2434 75.0767 86.2634 74.9247 86.3034C74.8927 86.9114 74.8687 87.6474 74.8527 88.5114C75.3807 88.6794 75.7767 88.7634 76.0407 88.7634ZM81.581 91.7634C81.349 91.7634 81.065 91.7394 80.729 91.6914C80.769 91.2754 80.801 90.7234 80.825 90.0354C80.849 89.3394 80.861 88.6914 80.861 88.0914C80.861 87.5794 80.845 87.0594 80.813 86.5314C79.829 86.5394 79.217 86.5914 78.977 86.6874C78.937 86.4074 78.917 86.1714 78.917 85.9794C78.917 85.8194 78.937 85.6194 78.977 85.3794C79.305 85.4114 79.745 85.4394 80.297 85.4634C80.857 85.4794 81.385 85.4874 81.881 85.4874C83.073 85.4874 83.809 85.4354 84.089 85.3314C84.129 85.5874 84.149 85.7994 84.149 85.9674C84.149 86.1754 84.129 86.3994 84.089 86.6394C83.625 86.5994 83.017 86.5674 82.265 86.5434C82.225 87.3674 82.205 88.1754 82.205 88.9674C82.205 90.4314 82.269 91.3394 82.397 91.6914C82.181 91.7394 81.909 91.7634 81.581 91.7634ZM85.8191 91.7634C85.5631 91.7634 85.2711 91.7394 84.9431 91.6914C85.0311 90.4594 85.0751 89.2794 85.0751 88.1514C85.0751 86.6794 85.0111 85.7514 84.8831 85.3674C85.1471 85.3194 85.4271 85.2954 85.7231 85.2954C85.9631 85.2954 86.2391 85.3194 86.5511 85.3674C86.5111 85.7834 86.4791 86.3394 86.4551 87.0354C86.4311 87.7234 86.4191 88.3674 86.4191 88.9674C86.4191 90.4314 86.4831 91.3394 86.6111 91.6914C86.3471 91.7394 86.0831 91.7634 85.8191 91.7634ZM90.4754 91.8234C89.5714 91.8234 88.8754 91.5634 88.3874 91.0434C87.8994 90.5154 87.6554 89.7674 87.6554 88.7994C87.6554 88.1194 87.7954 87.5154 88.0754 86.9874C88.3634 86.4514 88.7594 86.0354 89.2634 85.7394C89.7754 85.4434 90.3594 85.2954 91.0154 85.2954C91.7434 85.2954 92.3394 85.3914 92.8034 85.5834C92.8034 85.8154 92.7514 86.0834 92.6474 86.3874C92.5514 86.6834 92.4434 86.8994 92.3234 87.0354C92.0034 86.7794 91.6634 86.5634 91.3034 86.3874C90.9434 86.2114 90.6594 86.1234 90.4514 86.1234C90.2114 86.1874 89.9874 86.3394 89.7794 86.5794C89.5794 86.8114 89.4194 87.0954 89.2994 87.4314C89.1794 87.7674 89.1194 88.1114 89.1194 88.4634C89.1194 89.1914 89.2754 89.7394 89.5874 90.1074C89.8994 90.4674 90.3394 90.6474 90.9074 90.6474C91.2594 90.6474 91.6074 90.6034 91.9514 90.5154C92.2954 90.4274 92.5834 90.3074 92.8154 90.1554L92.9714 90.7554C92.6914 91.0754 92.3234 91.3354 91.8674 91.5354C91.4114 91.7274 90.9474 91.8234 90.4754 91.8234ZM94.7488 91.7634C94.4928 91.7634 94.2008 91.7394 93.8728 91.6914C93.9608 90.4594 94.0048 89.2794 94.0048 88.1514C94.0048 86.6794 93.9408 85.7514 93.8128 85.3674C94.0768 85.3194 94.3568 85.2954 94.6528 85.2954C94.8928 85.2954 95.1688 85.3194 95.4808 85.3674C95.4408 85.7834 95.4088 86.3394 95.3848 87.0354C95.3608 87.7234 95.3488 88.3674 95.3488 88.9674C95.3488 90.4314 95.4128 91.3394 95.5408 91.6914C95.2768 91.7394 95.0128 91.7634 94.7488 91.7634ZM97.7371 91.7634C97.4811 91.7634 97.1891 91.7394 96.8611 91.6914C96.9011 91.2994 96.9331 90.7634 96.9571 90.0834C96.9811 89.3954 96.9931 88.7514 96.9931 88.1514C96.9931 86.7834 96.9291 85.9434 96.8011 85.6314C97.0571 85.5354 97.4091 85.4594 97.8571 85.4034C98.3051 85.3394 98.7531 85.3074 99.2011 85.3074C100.041 85.3074 100.685 85.4914 101.133 85.8594C101.589 86.2194 101.817 86.7394 101.817 87.4194C101.817 87.8754 101.701 88.2834 101.469 88.6434C101.237 88.9954 100.913 89.2714 100.497 89.4714C100.089 89.6714 99.6171 89.7714 99.0811 89.7714C98.8491 89.7714 98.6051 89.7514 98.3491 89.7114C98.3651 90.7354 98.4251 91.3954 98.5291 91.6914C98.2651 91.7394 98.0011 91.7634 97.7371 91.7634ZM99.5251 89.0034C99.7651 88.8754 99.9611 88.6794 100.113 88.4154C100.273 88.1434 100.353 87.8434 100.353 87.5154C100.353 86.6674 99.8851 86.2434 98.9491 86.2434C98.7411 86.2434 98.5611 86.2634 98.4091 86.3034C98.3611 87.2474 98.3371 88.0674 98.3371 88.7634C98.8571 88.9234 99.2531 89.0034 99.5251 89.0034ZM107.591 91.7514C107.343 91.7514 107.075 91.7234 106.787 91.6674C106.539 90.9554 106.363 90.4594 106.259 90.1794C105.835 90.1554 105.371 90.1434 104.867 90.1434C104.323 90.1434 103.939 90.1594 103.715 90.1914C103.579 90.5514 103.403 91.0434 103.187 91.6674C103.011 91.7154 102.851 91.7394 102.707 91.7394C102.523 91.7394 102.335 91.7154 102.143 91.6674C102.367 91.2674 102.763 90.3234 103.331 88.8354C103.899 87.3474 104.323 86.1834 104.603 85.3434C104.883 85.3034 105.119 85.2834 105.311 85.2834C105.511 85.2834 105.731 85.3034 105.971 85.3434C106.251 86.1834 106.675 87.3474 107.243 88.8354C107.811 90.3234 108.207 91.2674 108.431 91.6674C108.175 91.7234 107.895 91.7514 107.591 91.7514ZM105.323 89.3154C105.491 89.3154 105.695 89.3074 105.935 89.2914C105.559 88.2514 105.243 87.4354 104.987 86.8434C104.731 87.4674 104.419 88.2794 104.051 89.2794C104.443 89.3034 104.867 89.3154 105.323 89.3154ZM109.681 91.7634C109.521 91.7634 109.325 91.7394 109.093 91.6914C109.157 90.8594 109.189 89.6794 109.189 88.1514C109.189 86.6714 109.145 85.7434 109.057 85.3674C109.281 85.3194 109.541 85.2954 109.837 85.2954C110.069 85.2954 110.365 85.3194 110.725 85.3674C110.981 85.8714 111.373 86.5874 111.901 87.5154C112.437 88.4434 112.937 89.2914 113.401 90.0594C113.417 89.2114 113.425 88.5554 113.425 88.0914C113.425 86.6034 113.381 85.6954 113.293 85.3674C113.461 85.3194 113.629 85.2954 113.797 85.2954C113.973 85.2954 114.173 85.3194 114.397 85.3674C114.333 86.4074 114.301 87.5874 114.301 88.9074C114.301 90.3714 114.345 91.2994 114.433 91.6914C114.217 91.7394 113.961 91.7634 113.665 91.7634C113.393 91.7634 113.089 91.7394 112.753 91.6914C112.497 91.2034 112.105 90.4994 111.577 89.5794C111.057 88.6514 110.561 87.7914 110.089 86.9994C110.073 87.8474 110.065 88.5034 110.065 88.9674C110.065 90.4074 110.109 91.3154 110.197 91.6914C110.029 91.7394 109.857 91.7634 109.681 91.7634ZM117.745 91.7634C117.513 91.7634 117.229 91.7394 116.893 91.6914C116.933 91.2754 116.965 90.7234 116.989 90.0354C117.013 89.3394 117.025 88.6914 117.025 88.0914C117.025 87.5794 117.009 87.0594 116.977 86.5314C115.993 86.5394 115.381 86.5914 115.141 86.6874C115.101 86.4074 115.081 86.1714 115.081 85.9794C115.081 85.8194 115.101 85.6194 115.141 85.3794C115.469 85.4114 115.909 85.4394 116.461 85.4634C117.021 85.4794 117.549 85.4874 118.045 85.4874C119.237 85.4874 119.973 85.4354 120.253 85.3314C120.293 85.5874 120.313 85.7994 120.313 85.9674C120.313 86.1754 120.293 86.3994 120.253 86.6394C119.789 86.5994 119.181 86.5674 118.429 86.5434C118.389 87.3674 118.369 88.1754 118.369 88.9674C118.369 90.4314 118.433 91.3394 118.561 91.6914C118.345 91.7394 118.073 91.7634 117.745 91.7634Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_di_308_8132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.1104 47.5486C97.8898 47.9416 97.5675 48.0622 97.1687 48.0561C96.2175 48.0392 95.2662 48.0513 94.315 48.0501C94.21 48.0501 94.1029 48.0501 93.9989 48.0344C93.6108 47.9717 93.3542 47.6559 93.3595 47.2568C93.3648 46.8637 93.6384 46.4984 94.0127 46.4924C95.1612 46.4707 96.3118 46.4562 97.4593 46.5081C97.682 46.5177 97.893 46.8336 98.1104 47.0084V47.5498V47.5486Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.142 59.9325C70.4403 59.9711 64.8964 54.2909 64.8538 47.3425C64.8111 40.3731 70.3188 34.6258 77.0717 34.5939C83.8086 34.562 89.3674 40.2399 89.4005 47.1861C89.4346 54.1974 83.9557 59.8929 77.142 59.9325ZM70.5746 55.5571C70.5555 56.2783 71.0757 56.5766 71.6781 56.2474C73.3797 55.3182 75.0812 54.3889 76.771 53.4388C77.0418 53.2868 77.2369 53.2989 77.4992 53.4465C79.1794 54.3878 80.8693 55.3094 82.5548 56.2408C82.8416 56.3994 83.122 56.4764 83.4131 56.2607C83.6924 56.0548 83.7169 55.7586 83.6657 55.4481C83.3416 53.4619 83.0207 51.4757 82.6774 49.4927C82.6241 49.1834 82.6859 48.9896 82.9002 48.7738C84.2617 47.403 85.6093 46.018 86.9622 44.6384C87.2042 44.3918 87.4292 44.1429 87.2917 43.7433C87.1563 43.3513 86.8375 43.2831 86.4985 43.2335C84.6199 42.955 82.7425 42.672 80.865 42.3945C80.6272 42.3593 80.4769 42.2624 80.3628 42.0158C79.5409 40.2344 78.6954 38.465 77.8659 36.688C77.7082 36.3489 77.5344 36.056 77.1175 36.0604C76.722 36.0659 76.5503 36.3434 76.3979 36.6693C75.5674 38.4463 74.724 40.2167 73.8989 41.9971C73.7816 42.2492 73.6334 42.367 73.3711 42.4044C71.4659 42.6786 69.5608 42.9538 67.6598 43.2588C67.4263 43.2963 67.1502 43.4614 67.0148 43.6574C66.7707 44.0108 66.9828 44.3235 67.2483 44.5933C68.6311 46.0003 70.0139 47.4074 71.3838 48.8288C71.5043 48.9532 71.612 49.1856 71.5885 49.3474C71.4446 50.3636 71.2612 51.3744 71.0939 52.3873C70.9147 53.4674 70.7399 54.5486 70.5746 55.5571Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0655 60.1492C83.9837 59.5704 84.9161 59.0363 85.7852 58.421C86.9523 57.5944 87.9119 56.5648 88.7111 55.4061C88.852 55.2021 88.9797 55.1594 89.2363 55.1948C90.9438 55.429 92.6557 55.6362 94.3654 55.8527C94.4462 55.8632 94.5368 55.859 94.6056 55.8933C94.729 55.9548 94.9157 56.0256 94.9364 56.1203C94.9626 56.2421 94.8949 56.4368 94.7945 56.5211C94.2857 56.9521 93.7606 57.3654 93.2245 57.7641C93.1132 57.8464 92.9188 57.887 92.778 57.8641C91.8008 57.7058 90.8281 57.5257 89.8542 57.3519C89.7614 57.3352 89.6697 57.3092 89.5758 57.2915C89.1315 57.2092 88.7908 57.3935 88.6904 57.7704C88.6009 58.1056 88.8247 58.4679 89.2341 58.5574C90.1468 58.7552 91.0628 58.9499 91.9864 59.0967C92.4395 59.1685 92.7398 59.282 92.8992 59.7546C93.2125 60.6905 93.6143 61.6004 93.9724 62.5228C94.1449 62.9663 93.9691 63.1641 93.4745 63.085C89.9372 62.5155 86.521 61.5525 83.2173 60.22C83.1573 60.196 83.0994 60.1658 83.0645 60.1502L83.0655 60.1492Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1871 60.1351C70.4116 60.428 69.6825 60.7136 68.9459 60.9783C66.2915 61.9309 63.5669 62.6364 60.7719 63.0856C60.2884 63.1638 60.1175 62.9606 60.2916 62.5124C60.6583 61.5651 61.0563 60.6281 61.3927 59.6703C61.529 59.2826 61.7681 59.1659 62.1466 59.1023C63.0606 58.9481 63.9703 58.7678 64.8757 58.575C65.3829 58.4666 65.6242 58.1279 65.5182 57.7537C65.4057 57.3556 65.0617 57.2013 64.5533 57.2972C63.5376 57.49 62.522 57.6849 61.5009 57.8496C61.3311 57.8767 61.1018 57.8027 60.959 57.6995C60.496 57.3639 60.0493 57.0054 59.621 56.6292C59.4793 56.5041 59.4122 56.3009 59.3105 56.1331C59.4977 56.0372 59.6772 55.8819 59.8741 55.8559C61.0747 55.6995 62.2818 55.5807 63.4836 55.4338C64.0168 55.3681 64.5447 55.2535 65.0779 55.1857C65.1904 55.1711 65.3721 55.2337 65.4316 55.3191C66.8594 57.3775 68.7339 58.9377 71.04 60.0215C71.0724 60.0372 71.0973 60.0653 71.1882 60.1351H71.1871Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5206 29.0296C77.5206 29.5583 77.5248 30.087 77.5194 30.6157C77.5146 31.1041 77.3558 31.4236 77.129 31.4268C76.9022 31.43 76.7367 31.1104 76.7343 30.6242C76.7295 29.5668 76.7289 28.5094 76.7343 27.452C76.7367 26.9573 76.8944 26.6685 77.135 26.6759C77.3642 26.6834 77.5128 26.9679 77.5188 27.4435C77.5254 27.9722 77.5206 28.5009 77.5206 29.0296Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4888 48.0527C57.9731 48.0527 57.4584 48.0624 56.9427 48.0503C56.4312 48.0381 56.1447 47.7488 56.1426 47.2705C56.1405 46.779 56.4471 46.4787 56.9714 46.4763C58.0018 46.4714 59.0332 46.4714 60.0636 46.4763C60.573 46.4787 60.903 46.8068 60.8934 47.2802C60.8839 47.7415 60.5783 48.0394 60.0742 48.0503C59.5457 48.0611 59.0173 48.0527 58.4888 48.0527Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4358 35.498C66.2478 35.7135 66.1094 35.9512 65.9052 36.0883C65.6383 36.2685 65.3552 36.1557 65.1358 35.9391C64.6831 35.4891 64.24 35.0281 63.7938 34.5705C63.4426 34.2112 63.086 33.8552 62.7402 33.4893C62.4052 33.1333 62.3912 32.7364 62.6883 32.4324C62.9812 32.134 63.3853 32.145 63.7235 32.4855C64.508 33.277 65.2893 34.0719 66.0587 34.8789C66.2002 35.0281 66.2802 35.2382 66.4336 35.498H66.4358Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5673 32.8925C92.3794 33.1544 92.2835 33.3644 92.1136 33.5136C91.2024 34.3103 90.2769 35.0959 89.3474 35.8783C88.9041 36.2518 88.4336 36.2728 88.0693 35.9601C87.7038 35.6462 87.7323 35.2462 88.1678 34.8705C89.0986 34.0705 90.0357 33.276 90.9716 32.4804C91.2477 32.2461 91.59 32.1245 91.9296 32.3069C92.1759 32.4395 92.3418 32.6793 92.5673 32.8925Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1869 31.5569C71.1671 31.8552 71.0065 32.0899 70.6655 32.1801C70.3153 32.2724 69.9673 32.2037 69.8068 31.8982C69.4623 31.2412 69.1435 30.5728 68.8572 29.8942C68.7164 29.5611 68.9224 29.2454 69.2773 29.109C69.6078 28.9819 70.0255 29.0619 70.1815 29.3581C70.5387 30.0377 70.8447 30.7379 71.1694 31.4308C71.1857 31.4646 71.181 31.5056 71.188 31.5559L71.1869 31.5569Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0096 41.7181C60.9018 41.6795 60.7765 41.6467 60.6583 41.5916C60.1102 41.3375 59.5631 41.0834 59.0191 40.8199C58.5829 40.6079 58.415 40.1922 58.5798 39.7706C58.7342 39.3747 59.102 39.2365 59.5331 39.4309C60.1185 39.6956 60.7039 39.9603 61.279 40.2531C61.5909 40.4112 61.7432 40.7063 61.6645 41.1091C61.5898 41.4921 61.3463 41.6478 61.0096 41.7193V41.7181Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.996 32.2181C83.3179 32.2202 82.9303 31.8002 83.1071 31.3749C83.3823 30.7106 83.6973 30.0566 84.0288 29.412C84.1997 29.0782 84.6366 28.9691 84.9973 29.1126C85.3322 29.2456 85.5348 29.6002 85.3954 29.9246C85.1155 30.5744 84.8228 31.2231 84.4808 31.848C84.3777 32.0362 84.0955 32.1464 83.996 32.2181Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7338 40.1616C95.5829 40.3698 95.4665 40.6615 95.2742 40.7697C94.6769 41.1085 94.0554 41.3873 93.4348 41.6685C93.117 41.812 92.7789 41.6391 92.6382 41.305C92.4863 40.9438 92.5764 40.498 92.8993 40.3215C93.5239 39.9828 94.1607 39.664 94.8085 39.391C95.2408 39.2087 95.6427 39.5722 95.7328 40.1616H95.7338Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4658 53.5937C72.6519 52.5111 72.824 51.506 72.9961 50.502C73.0864 49.9745 73.1596 49.4438 73.2693 48.9205C73.3424 48.5692 73.2349 48.3123 72.9843 48.0714C71.9506 47.0758 70.9255 46.0718 69.8982 45.0699C69.8122 44.986 69.7326 44.8979 69.6035 44.7642C70.2532 44.6687 70.8459 44.5806 71.4386 44.4935C72.3894 44.3534 73.3381 44.2006 74.2912 44.0817C74.6719 44.034 74.8774 43.8408 75.0334 43.5181C75.6443 42.2572 76.2693 41.0027 76.8888 39.746C76.948 39.6271 77.0104 39.5104 77.0975 39.3438C77.1803 39.4881 77.2481 39.5942 77.304 39.7067C77.9301 40.974 78.5615 42.2402 79.1746 43.5139C79.3381 43.8535 79.5618 44.0361 79.9512 44.0891C81.3915 44.2823 82.8285 44.5031 84.2667 44.7143C84.3603 44.7281 84.4538 44.7483 84.5474 44.7663L84.6485 44.8947C84.5313 44.9605 84.3925 45.0051 84.2989 45.0953C83.2835 46.075 82.28 47.0652 81.2624 48.0417C80.9913 48.3007 80.8752 48.5671 80.9451 48.9502C81.1979 50.3258 81.4248 51.7056 81.6604 53.0832C81.6851 53.2254 81.7023 53.3698 81.7314 53.5757C81.5969 53.5152 81.5033 53.4791 81.4162 53.4324C80.1534 52.7712 78.8874 52.1163 77.6321 51.4413C77.2707 51.247 76.9588 51.2396 76.592 51.4381C75.3281 52.1227 74.0502 52.7818 72.7777 53.4504C72.7035 53.4897 72.6261 53.5226 72.468 53.5969L72.4658 53.5937Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_308_8132",
    x: 17.3418,
    y: 76.4287,
    width: 120.139,
    height: 28.9463,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.21 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_308_8132"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_308_8132",
    x: 31.0139,
    y: 85.2832,
    width: 93.2992,
    height: 14.54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_308_8132"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_308_8132",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_di_308_8132",
    x: 52.1426,
    y: 25.6758,
    width: 49.9678,
    height: 45.4258,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_308_8132"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_308_8132",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0166667 0 0 0 0 0.0166667 0 0 0 0 0.0166667 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_308_8132"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_308_8132",
    x1: 105.172,
    y1: 32.9611,
    x2: 153.735,
    y2: 32.9611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B4869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC5E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_308_8132",
    x1: 105.172,
    y1: 36.8698,
    x2: 149.702,
    y2: 36.8698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA9CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A3ACCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AFB8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C3CBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E6F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_308_8132",
    x1: 0.710286,
    y1: 45.3484,
    x2: 143.382,
    y2: 45.3484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B4869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC5E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_308_8132",
    x1: 0.713578,
    y1: 49.2532,
    x2: 139.359,
    y2: 49.2532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA9CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A3ACCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AFB8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C3CBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E6F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_308_8132",
    x1: 0.713556,
    y1: 57.7317,
    x2: 133.033,
    y2: 57.7317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B4869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC5E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_308_8132",
    x1: 0.713564,
    y1: 61.6379,
    x2: 129.006,
    y2: 61.6379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA9CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A3ACCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AFB8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#C3CBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E6F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_308_8132",
    x1: 0.712891,
    y1: 32.9611,
    x2: 49.2756,
    y2: 32.9611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFC5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B4869"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_308_8132",
    x1: 4.74219,
    y1: 36.8698,
    x2: 49.278,
    y2: 36.8698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C3CBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AFB8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A3ACCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FA9CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_308_8132",
    x1: 11.0677,
    y1: 45.3484,
    x2: 1.23895,
    y2: 45.3484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFC5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B4869"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_308_8132",
    x1: 15.0938,
    y1: 49.2532,
    x2: 1.23815,
    y2: 49.2532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C3CBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AFB8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A3ACCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FA9CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_308_8132",
    x1: 21.4141,
    y1: 57.7317,
    x2: 1.23809,
    y2: 57.7317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFC5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B4869"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_308_8132",
    x1: 25.4453,
    y1: 61.6379,
    x2: 1.23729,
    y2: 61.6379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C3CBE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#AFB8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A3ACCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9FA9CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_308_8132",
    x1: 77.2235,
    y1: 95.2938,
    x2: 77.2235,
    y2: 12.8776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40526F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#717F8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_308_8132",
    x1: 32.7923,
    y1: 10.5849,
    x2: 77.2235,
    y2: 10.5849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CDE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFDBF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_308_8132",
    x1: 38.3633,
    y1: 15.2662,
    x2: 77.2228,
    y2: 15.2662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41475E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666F7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_308_8132",
    x1: 55.0092,
    y1: 105.914,
    x2: 55.0092,
    y2: 14.7578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4C0D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_308_8132",
    x1: 57.797,
    y1: 100.037,
    x2: 57.797,
    y2: 18.4062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5674"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#546381"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_308_8132",
    x1: 77.2233,
    y1: 10.5849,
    x2: 121.66,
    y2: 10.5849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4C0D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737A99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_308_8132",
    x1: 77.2227,
    y1: 0.551855,
    x2: 116.087,
    y2: 0.551855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41475E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666F7E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_308_8132",
    x1: 99.4408,
    y1: 105.914,
    x2: 99.4408,
    y2: 14.7578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E3A52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#576081"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_308_8132",
    x1: 96.6557,
    y1: 100.037,
    x2: 96.6557,
    y2: 18.4062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4C0D1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_308_8132",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(77.2216 70.1269) scale(74.682 74.682)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#DFE2ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C3C9DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#AFB7D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#A3ACCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#9FA9CA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_308_8132",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(77.0213 54.5286) scale(42.9597 42.9597)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA5B2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_308_8132",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.6382 -6.07425) scale(65.7236 66.3875)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEB6DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927793,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_308_8132",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.617 -21.7576) scale(65.4405)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEB6DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_308_8132",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.9105 12.8773) scale(12.3266)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5C3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#7A90AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#556476"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#37404C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#1F252B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#0E1114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#040505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarParticipant);
export default __webpack_public_path__ + "static/media/star-participant.0cadae6c89e81db2aa8775fe4823cd37.svg";
export { ForwardRef as ReactComponent };